import { useContext, useEffect } from 'react';
import CallEndIcon from '@mui/icons-material/CallEnd';
import { useMeetingManager } from 'amazon-chime-sdk-component-library-react';

import { ChimeMessageContext } from '../../../../../context';
import { RouteType } from '../../../../../router';
import RealWareButton from './realware-button';
import { MeetingJoinType } from '../../../../../types';


const LeaveCallButton: React.FC = () => {
    const meetingManager = useMeetingManager();

    const { subscribeToChannel } = useContext(ChimeMessageContext);

    const url = () => {
        const baseUrl = window.location.origin;
        const url = new URL(`${baseUrl}${RouteType.MeetingLeft}`);

        // Copy all optional params from current URL, except those already set
        const currentParams = new URLSearchParams(window.location.search);
        currentParams.forEach((value, key) => {
            if (!url.searchParams.has(key)) {
                url.searchParams.append(key, value);
            }
        });

        url.searchParams.set("joinType", MeetingJoinType.Headset);

        return url.toString();
    };

    const leaveCall = () => {
        if (meetingManager) {
            meetingManager.leave();
        }

        window.location.href = url();
    }

    useEffect(() => {
        subscribeToChannel("leaveCall", "labelled-leaveCall-button", (message) => {
            if (message.payload == "join") {
                return;
            }

            console.log("~~Received leave call message", message);
            leaveCall();
        })

    }, [leaveCall]);



    return (
        <RealWareButton
            active={true}
            activeIcon={<CallEndIcon color="action" />}
            activeLabel={"Leave Call"}
            inactiveLabel={"Leave Call"}
            activeColor="#c62828"
            showText={true}
            onClick={leaveCall}
        />
    )
}

export default LeaveCallButton;